import { css, keyframes } from "@emotion/react";

import type { ExactTheme } from "src/lib/emotion/theme.ts";

const slideDown = keyframes({
  from: {
    opacity: 0,
    maxHeight: 0,
  },
  to: {
    opacity: 1,
    maxHeight: "var(--radix-accordion-content-height)",
  },
});

const slideUp = keyframes({
  from: {
    opacity: 1,
    maxHeight: "var(--radix-accordion-content-height)",
  },
  to: {
    opacity: 0,
    maxHeight: 0,
  },
});

export const itemStyle = ({ borderRadiusV2, colorsV2 }: ExactTheme) =>
  css({
    overflow: "hidden",
    marginTop: 1,
    borderTopLeftRadius: borderRadiusV2.primary,
    borderTopRightRadius: borderRadiusV2.primary,
    color: colorsV2.grey[900],

    "&:not(:first-of-type)": {
      marginTop: 15,
    },

    "&:focus-within": {
      position: "relative",
      zIndex: 1,
    },
  });

export const triggerStyle = ({ colorsV2 }: ExactTheme) =>
  css({
    padding: 10,
    position: "relative",
    display: "flex",
    border: "none",
    backgroundColor: "transparent",
    width: "100%",
    height: 40,
    cursor: "pointer",
    flex: 1,
    gap: 10,
    alignItems: "center",
    transition: "background-color 0.3s",

    '&[data-state="open"]': {
      backgroundColor: colorsV2.grey[50],
      borderBottom: "1px solid transparent",
    },
    '&[data-state="closed"]': {
      borderBottom: `1px solid ${colorsV2.grey[100]}`,
      "&:hover": {
        backgroundColor: colorsV2.grey[25],
      },
    },
  });

export const contentStyle = ({
  fontSizesV2,
  colorsV2,
  borderRadiusV2,
}: ExactTheme) =>
  css({
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
    gap: 10,
    overflow: "hidden",
    backgroundColor: colorsV2.grey[25],
    fontSize: fontSizesV2.body,
    borderBottomLeftRadius: borderRadiusV2.primary,
    borderBottomRightRadius: borderRadiusV2.primary,

    '&[data-state="open"]': {
      animation: `${slideDown} 0.3s`,
    },
    '&[data-state="closed"]': {
      animation: `${slideUp} 0.3s`,
    },
  });

export const contentInner = css({
  padding: "10px",
  gap: 10,
  display: "flex",
  flexDirection: "column",
});

export const listPriceText = ({ fontSizesV2, fontWeights }: ExactTheme) =>
  css({
    fontSize: fontSizesV2.body,
    fontWeight: fontWeights.medium,
    display: "flex",
    alignItems: "center",
    height: "35px",
  });

export const chevron = css({
  transformOrigin: "center",
  transition: "transform 0.3s",
  '[data-state="open"] &': {
    transform: "rotate(180deg)",
  },
});

export const chevronContainer = css({
  width: "25px",
  height: "25px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

export const dateLabel = (theme: ExactTheme) =>
  css({
    fontSize: theme.fontSizesV2.body,
    fontWeight: theme.fontWeights.normal,
  });

export const typeLabel = () => (theme: ExactTheme) =>
  css({
    marginRight: "10px",
    fontSize: theme.fontSizesV2.body,
    fontWeight: theme.fontWeights.semibold,
  });

export const deleteIconContainer = (theme: ExactTheme) =>
  css({
    color: theme.colorsV2.red[500],
    fontSize: "15px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  });
